import moment from "moment-jalaali";
export function cal_dis(s, e, x = 0) {
  let toRadians = (degrees) => (degrees * Math.PI) / 180;
  let latFrom = toRadians(s[0]);
  let lonFrom = toRadians(s[1]);
  let latTo = toRadians(e[0]);
  let lonTo = toRadians(e[1]);

  let latDelta = latTo - latFrom;
  let lonDelta = lonTo - lonFrom;

  let a =
    Math.sin(latDelta / 2) * Math.sin(latDelta / 2) +
    Math.cos(latFrom) *
      Math.cos(latTo) *
      Math.sin(lonDelta / 2) *
      Math.sin(lonDelta / 2);
  let d = 12742 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  if (x === 1) return d;
  if (d <= 0.5) d = parseInt(d * 20) * 50 + 50 + "-متر";
  else if (d <= 1) d = parseInt(d * 10) * 100 + 100 + "-متر";
  else if (d <= 10) d = parseInt(parseInt(d * 20) / 10) / 2 + 0.5 + "-کیلومتر";
  else d = parseInt(d) + 1 + "-کیلومتر";
  return d;
}

export const convertDate = (date, time = true) => {
  if (time) {
    return moment.unix(parseInt(date)).format("jYYYY/jM/jD----hh:mm:ss a");
  }
  return moment.unix(parseInt(date)).format("jYYYY/jM/jD");
};
export function formatTimeRange(data) {
  const { start_1, end_1, start_2, end_2 } = data;

  const isValidTime = (time) => time !== "00:00:00";

  const format = (t) => t.slice(0, 5); // from "07:00:00" => "07:00"

  const parts = [];

  if (isValidTime(start_1) && isValidTime(end_1)) {
    parts.push(`${format(start_1)} - ${format(end_1)}`);
  }

  if (isValidTime(start_2) && isValidTime(end_2)) {
    parts.push(`${format(start_2)} - ${format(end_2)}`);
  }

  if (parts.length === 0) {
    return "Closed";
  }

  return parts.join(" / ");
}

export const userTypeHandler = (type) => {
  switch (type) {
    case "user":
      return "مشتری";

    case "supplier":
      return "تامین کننده";

    case "deliver":
      return "پیک";

    default:
      break;
  }
};
export const orderTypeHandler = (type) => {
  switch (type) {
    case "-3":
      return "پرداخت نشده";

    case "-2":
      return "لغو شده";

    case "-1":
      return "لغو شده";

    case "3":
      return "تکمیل شده";

    default:
      break;
  }
};
export function formatRemainingTime(seconds) {
  // بررسی اینکه آیا زمان گذشته است (عدد منفی است)
  const isPassed = seconds < 0;

  // تبدیل به عدد مثبت برای انجام محاسبات زمان
  const absSeconds = Math.abs(seconds);

  let timeString = "";

  if (absSeconds < 60) {
    timeString = `${Math.floor(absSeconds)} ثانیه`;
  } else {
    const minutes = absSeconds / 60;
    if (minutes < 60) {
      timeString = `${Math.floor(minutes)} دقیقه`;
    } else {
      const hours = minutes / 60;
      if (hours < 24) {
        timeString = `${Math.floor(hours)} ساعت`;
      } else {
        const days = hours / 24;
        timeString = `${Math.floor(days)} روز`;
      }
    }
  }

  // اضافه کردن پسوند مناسب بر اساس مثبت یا منفی بودن زمان
  return isPassed
    ? `${timeString} از سر رسید شما گذشت`
    : `${timeString} تا سر رسید قسط شما مانده`;
}

export function calcDiscountPercent(original, discounted, decimals = 0) {
  const o = parseFloat(original);
  const d = parseFloat(discounted);

  if (!isFinite(o) || !isFinite(d) || o <= 0) return 0;

  let percent = ((o - d) / o) * 100;

  if (!isFinite(percent)) return 0;
  if (percent < 0) percent = 0;

  const factor = Math.pow(10, Math.max(0, Math.trunc(decimals)));
  return Math.round(percent * factor) / factor;
}

export function randomNumberInRange(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
